// src/core/common/Preloader.tsx
import React from "react";

const Preloader: React.FC = () => (
  <div className="preloader">
    <div className="loader"></div>
  </div>
);

export default Preloader;
